export enum BaseTypes {
  string = 'string',
  number = 'number',
  function = 'function',
  object = 'object',
}
